"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalRole = exports.UserStatus = exports.firebaseConfig = void 0;
require("firebase/auth");
require("firebase/firestore");
exports.firebaseConfig = {
    prod: {
        apiKey: "AIzaSyBExAATUY_pseg2Kc4GVfRvUaNL750YkSE",
        authDomain: "qlarity-prod.firebaseapp.com",
        databaseURL: "https://qlarity-prod.firebaseio.com",
        projectId: "qlarity-prod",
        storageBucket: "qlarity-prod.appspot.com",
        messagingSenderId: "249922326700",
        appId: "1:249922326700:web:5a4a24d425f779272d4f09",
        measurementId: "G-QM1YRN083F",
    },
};
var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "pending";
    UserStatus["ACTIVE"] = "active";
    UserStatus["ARCHIVED"] = "archived";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var PortalRole;
(function (PortalRole) {
    PortalRole["ADMIN"] = "admin";
    PortalRole["ORG_ADMIN"] = "orgAdmin";
    PortalRole["CLINICIAN"] = "clinician";
})(PortalRole = exports.PortalRole || (exports.PortalRole = {}));
//# sourceMappingURL=firebaseConfig.js.map